module.exports = __webpack_public_path__ + "297c3361d7e123b67183a4c96e7a3319.png";